module.exports = __webpack_public_path__ + "static/media/NOWTEL.c872b8e9.svg";